import { Box, Drawer, IconButton, Paper, Stack, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {
	DrawerAuthButtonSx,
	DrawerAuthFrameSx,
	DrawerAuthHeaderIconCloseSx,
	DrawerAuthTitleSx,
} from '@/components/content/Cart/parts/DrawerAuth/styles/main';
import { DpBaseButton } from '@/components/blocks/DpBaseButton';

interface DrawerAuthProps {
	type?: 'login' | 'wishlist';
	onClose: () => void;
	onGoLogin: () => void;
	onGoRegister: () => void;
}

export const DrawerAuth: React.FC<DrawerAuthProps> = ({
	type = 'login',
	onClose,
	onGoLogin,
	onGoRegister,
}) => (
	<Drawer open>
		<Paper sx={DrawerAuthFrameSx}>
			<Typography sx={DrawerAuthTitleSx}>
				{type === 'wishlist' ? '¿CÓMO QUIERES CONTINUAR?' : '¿CÓMO QUIERES CONTINUAR TU COMPRA?'}
			</Typography>
			<CloseIcon sx={DrawerAuthHeaderIconCloseSx} onClick={onClose} />
			<DpBaseButton sx={DrawerAuthButtonSx} onClick={onGoLogin}>
				{type === 'wishlist' ? 'Continuar con mi cuenta' : 'Comprar con mi cuenta'}
			</DpBaseButton>
			<DpBaseButton variant="secondary" sx={DrawerAuthButtonSx} onClick={onGoRegister}>
				{'Me quiero registrar'}
			</DpBaseButton>
		</Paper>
	</Drawer>
);
